<template>
  <el-form :model="ruleForm" ref="ruleForm" label-position="top">
    <el-row :gutter="5">
      <el-col :xs="24" :sm="18" :md="16" :lg="12" :xl="12">
        <el-form-item :label="$t('servico')" prop="service">
          <el-input maxlength="120" ref="name" class="lowercase" v-model="ruleForm.service"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="24" :sm="18" :md="16" :lg="12" :xl="12">
        <el-form-item :label="$t('tipo')" prop="type">
          <el-radio-group v-model="ruleForm.type">
            <el-radio label="shipping">{{
              $t("transportadora")
            }}</el-radio>
            <el-radio label="motocycle">{{ $t("motoboy") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
        <el-form-item :label="$t('ativo')" prop="active" class="is-required">
          <el-switch v-model="ruleForm.active" inactive-color="#ff4949"></el-switch>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="24" :sm="18" :md="18" :lg="8" :xl="8">
        <el-form-item :label="$t('configuracao')" prop="configuration">
          <el-input type="textarea" :rows="4" v-model="ruleForm.configuration" ref="money" :min="1" :max="100"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  computed: {
    data() {
      return this.ruleForm;
    }
  },
  name: "ShippingIntegrationAddFormHeader",
  data() {
    return {
      ruleForm: {
        service: "",
        type: "shipping",
        active: true,
        configuration: "",
      },
    };
  },
};
</script>
<style>
.lowercase input {
  text-transform: lowercase;
}
</style>